module.exports = __webpack_public_path__ + "img/logo-avatar.90eb026d.png";